import React from 'react';
import { Link } from 'react-router-dom';
import BackButton from '../../../assets/images/back@2x.png';
import NextButton from '../../../assets/images/next@2x.png';

const AssessmentNavigation = ({children, className}) => (
    <div className={`assessment-navigation ${className}`}>{children}</div>
)

const AssessmentNavigationNext = ({children, onClick, to, className, style}) => {
    if (to !== undefined) {
        return (
            <AssessmentNavigation className={className}>
                <Link to={to}>
                    <img src={NextButton} alt="Next" style={{width:'4em', height:'auto', margin:'0em 2em 0em 4em', ...style}} />
                </Link>
            </AssessmentNavigation>
        );
    } else if (onClick !== undefined) {
        return (
            <AssessmentNavigation className={className}>
                <img src={NextButton} onClick={onClick} alt="Next" style={{width:'4em', height:'auto', margin:'0em 2em 0em 4em', ...style}} />
            </AssessmentNavigation>
        );
    } else {
        return (
            <div style={{pointerEvents: 'none', visibility: 'hidden', width:'4em', height:'auto', margin:'0em 2em 0em 4em'}}></div>
        );
    }
}

const AssessmentNavigationPrevious = ({children, onClick, to, className, style}) => {
    if (to !== undefined) {
        return (
            <AssessmentNavigation className={className}>
                <Link to={to}>
                    <img src={BackButton} alt="Next" style={{width:'4em', height:'auto', margin:'0em 4em 0em 2em'}} />
                </Link>
            </AssessmentNavigation>
        );
    } else if (onClick !== undefined) {
        return (
            <AssessmentNavigation className={className}>
                <img src={BackButton} onClick={onClick} alt="Next" style={{width:'4em', height:'auto', margin:'0em 4em 0em 2em', ...style}} />
            </AssessmentNavigation>
        );
    } else {
        return (
            <div style={{pointerEvents: 'none', visibility: 'hidden', width:'4em', height:'auto', margin:'0em 4em 0em 2em'}}></div>
        );
    }
}

export { 
    AssessmentNavigationPrevious,
    AssessmentNavigationNext
}